module.exports = __webpack_public_path__ + "r-v3/img/ml_42_00.86c2937d.jpg";